import { render, staticRenderFns } from "./AutomationsList.vue?vue&type=template&id=9c7d4f40"
import script from "./AutomationsList.vue?vue&type=script&lang=js"
export * from "./AutomationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports